<script setup>
import { onMounted } from "vue";
import useDefinitionTable from "./hooks/useDefinitionTable";

const {
  searchRef,
  searchData,
  tableLoading,
  tableData,
  columns,
  pages,
  getList,
  handleReset,
  handleDelete,
  handleActivateOrHang,
} = useDefinitionTable();

onMounted(() => {
  getList();
});

const tag_color = {
  act_suspend_status_001: "danger",
  act_suspend_status_002: "",
};

const changeBtn = {
  act_suspend_status_001: "激活",
  act_suspend_status_002: "挂起",
};

const button_color = {
  act_suspend_status_001: "success",
  act_suspend_status_002: "warning",
};
</script>

<template>
  <zh-table-page v-bind="{ title: '流程定义' }">
    <template #header-btn></template>
    <template #search>
      <el-form :model="searchData" ref="searchRef" :inline="true">
        <el-form-item prop="key">
          <el-input v-model="searchData.key" placeholder="流程key" />
        </el-form-item>
        <el-form-item prop="name">
          <el-input v-model="searchData.name" placeholder="流程名称" />
        </el-form-item>
        <el-form-item prop="systemId">
          <el-tree-select
            v-model="searchData.systemId"
            placeholder="所属系统"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="getList()"
            >搜索</el-button
          >
          <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        v-loading="tableLoading"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <el-tag
                v-if="item.prop == 'isSuspendedText'"
                :type="tag_color[row.isSuspended]"
                >{{ row[item.prop] }}</el-tag
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="编辑">
          <template #default="{ row }">
            <el-button
              :type="button_color[row.isSuspended]"
              link
              @click="handleActivateOrHang(row)"
              >{{ changeBtn[row.isSuspended] }}</el-button
            >
            <el-button type="danger" link @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :total="pages.total"
        v-model:current-page="pages.page"
        @update:current-page="getList"
        layout="->, prev, pager, next"
      />
    </template>
  </zh-table-page>
</template>

<style scoped></style>
